// The GST slabs an Indian hotel can put against a chargeable line. Kept in one place so
// the menu form and the check-in/checkout service config cannot drift apart, and so the
// list matches allowedGSTPercentages on the backend.
export const GST_OPTIONS = [0, 5, 12, 18, 28];

// What a new menu item starts on, and what an item that predates the GST field falls back
// to. 5% is the standard slab for restaurant service in India, so it is right far more
// often than 0 and saves the hotel setting it on every dish. A stored 0 is respected --
// only null/undefined takes this default.
export const DEFAULT_MENU_GST = 5;

export const formatGST = (value) =>
    value === null || value === undefined || value === "" ? "" : `${value}%`;

// Windows are stored as minutes past midnight. A window whose end is not after its start
// wraps midnight, which is how a 10 PM - 2 AM late-night menu is expressed.
export const minuteToClock = (minute) => {
    const hours = Math.floor(minute / 60);
    const minutes = minute % 60;
    const suffix = hours < 12 ? "AM" : "PM";
    const displayHour = hours % 12 === 0 ? 12 : hours % 12;
    return `${displayHour}:${String(minutes).padStart(2, "0")} ${suffix}`;
};

export const describeWindows = (windows) => {
    if (!windows || windows.length === 0) return "All day";
    return windows
        .map((window) => `${minuteToClock(window.start_minute)} - ${minuteToClock(window.end_minute)}`)
        .join(" | ");
};
